// extracted by mini-css-extract-plugin
module.exports = {"prose":"styles_prose__Ioj13","banner":"styles_banner__T9_1Q","tagsContainer":"styles_tagsContainer__vhDqP","tagTitle":"styles_tagTitle__h6C8r"};